(function () {
  'use strict';
  function money(cents) { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100); }
  function grundpreisHtml(item, className) {
    var m = item.unit_price_measurement;
    if (!item.unit_price || !m || !m.reference_unit) return '';
    var ref = (m.reference_value && m.reference_value !== 1 ? m.reference_value + ' ' : '') + m.reference_unit;
    return '<small class="grundpreis ' + className + '">' + money(item.unit_price) + ' / ' + ref + '</small>';
  }
  function escapeHtml(value) { return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function originalTotal(cart) { return cart.original_total_price == null ? cart.total_price : cart.original_total_price; }
  function OneACartDrawer() {
    this.drawer = document.getElementById('cd1a-drawer'); this.overlay = document.getElementById('cd1a-overlay');
    this.closeButton = document.getElementById('cd1a-close'); this.items = document.getElementById('cd1a-items');
    this.isOpen = false; this.busy = false; this.returnFocus = null;
    if (this.drawer) this.init();
  }
  OneACartDrawer.prototype.init = function () {
    var self = this;
    this.closeButton.addEventListener('click', function () { self.close(); });
    this.overlay.addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && self.isOpen) self.close(); });
    this.drawer.addEventListener('click', function (event) { self.handleClick(event); });
    var discountForm = this.drawer.querySelector('[data-cd1a-discount-form]');
    if (discountForm) discountForm.addEventListener('submit', function (event) {
      event.preventDefault(); self.applyDiscount(discountForm.elements.discount.value);
    });
    this.interceptFetch(); this.fetchAndRender();
  };
  OneACartDrawer.prototype.interceptFetch = function () {
    if (window.__oneACartFetchIntercepted) return;
    window.__oneACartFetchIntercepted = true;
    var self = this; var originalFetch = window.fetch.bind(window);
    window.fetch = function (input) {
      var response = originalFetch.apply(window, arguments);
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && url.indexOf('cart/add') !== -1) {
        response.then(function (result) {
          if (!result.ok) return;
          var opened = localStorage.getItem('1a_cart_opened_once');
          if (!opened) {
            localStorage.setItem('1a_cart_opened_once', '1');
            window.setTimeout(function () { self.open(); }, 200);
          } else { window.setTimeout(function () { self.fetchAndRender(); }, 100); }
        }).catch(function () {});
      }
      return response;
    };
  };
  OneACartDrawer.prototype.open = function () {
    if (!this.drawer) return;
    this.returnFocus = document.activeElement; this.isOpen = true;
    this.drawer.classList.add('is-open'); this.overlay.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false'); this.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; this.fetchAndRender();
    var self = this; window.setTimeout(function () { self.closeButton.focus(); }, 50);
  };
  OneACartDrawer.prototype.close = function () {
    if (!this.drawer) return;
    this.isOpen = false; this.drawer.classList.remove('is-open'); this.overlay.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true'); this.overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (this.returnFocus && typeof this.returnFocus.focus === 'function') this.returnFocus.focus();
  };
  OneACartDrawer.prototype.fetchAndRender = function () {
    var self = this;
    fetch('/cart.js').then(function (response) { return response.json(); }).then(function (cart) { self.render(cart); }).catch(function () {});
  };
  OneACartDrawer.prototype.render = function (cart) {
    this.cart = cart;
    this.renderItems(cart); this.renderTier(cart); this.renderTotals(cart); this.renderDiscount(cart); this.renderRecommendations(cart); this.updateBadge(cart.item_count);
    document.dispatchEvent(new CustomEvent('1a:cart:updated', { detail: cart }));
  };
  OneACartDrawer.prototype.renderItems = function (cart) {
    var empty = this.drawer.querySelector('[data-cd1a-empty]');
    this.drawer.querySelector('[data-cd1a-tier]').hidden = cart.item_count === 0;
    this.drawer.querySelector('.cd1a-footer').hidden = cart.item_count === 0;
    empty.hidden = cart.item_count !== 0;
    document.getElementById('cd1a-count').textContent = cart.item_count + ' Artikel';
    if (!cart.item_count) { this.items.innerHTML = ''; return; }
    this.items.innerHTML = cart.items.map(function (item) {
      var variant = item.variant_title && !/^(default title|standardtitel|standard|default)$/i.test(item.variant_title) ? '<span class="cd1a-item__variant">' + escapeHtml(item.variant_title) + '</span>' : '';
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '" width="60" height="60" loading="lazy" alt="' + escapeHtml(item.product_title) + '">' : '';
      var oldPrice = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
      return '<article class="cd1a-item" data-key="' + escapeHtml(item.key) + '" role="listitem">'
        + '<a class="cd1a-item__image" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' + image + '</a>'
        + '<div class="cd1a-item__info"><a class="cd1a-item__name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant + '</div>'
        + '<div class="cd1a-item__bottom"><div class="cd1a-qty"><button type="button" data-quantity="' + (item.quantity - 1) + '" aria-label="Menge von ' + escapeHtml(item.product_title) + ' verringern"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg></button><span>' + item.quantity + '</span><button type="button" data-quantity="' + (item.quantity + 1) + '" aria-label="Menge von ' + escapeHtml(item.product_title) + ' erhöhen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button></div><div class="cd1a-item__price">' + money(item.final_line_price) + oldPrice + grundpreisHtml(item, 'cd1a-item__grundpreis') + '</div></div>'
        + '<button class="cd1a-item__remove" type="button" data-quantity="0" aria-label="' + escapeHtml(item.product_title) + ' entfernen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button></article>';
    }).join('');
  };
  OneACartDrawer.prototype.renderTier = function (cart) {
    if (!window.BundleStaffel || !cart.item_count) return;
    var result = window.BundleStaffel.calculate(cart.item_count, originalTotal(cart));
    var primary = this.drawer.querySelector('[data-cd1a-tier-primary]'); var secondary = this.drawer.querySelector('[data-cd1a-tier-secondary]');
    if (result.next) {
      primary.textContent = 'Noch ' + result.remaining + ' Produkt für ' + result.next.percent + ' % auf alles';
      secondary.textContent = money(result.additionalSavingsCents) + ' mehr Ersparnis mit dem Code ' + window.BundleStaffel.codeForTier(result.next); secondary.hidden = false;
    } else { primary.textContent = 'Höchste Stufe erreicht'; secondary.textContent = ''; secondary.hidden = true; }
    this.drawer.querySelectorAll('[data-tier-minimum]').forEach(function (segment) { segment.classList.toggle('is-reached', result.quantity >= Number(segment.dataset.tierMinimum)); });
  };
  OneACartDrawer.prototype.renderTotals = function (cart) {
    var before = originalTotal(cart); var savings = Math.max(0, before - cart.total_price);
    document.getElementById('cd1a-subtotal').textContent = money(before);
    this.drawer.querySelector('[data-cd1a-total]').textContent = money(cart.total_price);
    this.drawer.querySelector('[data-cd1a-savings]').textContent = '−' + money(savings);
  };
  OneACartDrawer.prototype.showDiscountError = function (message) {
    var error = this.drawer.querySelector('[data-cd1a-discount-error]');
    error.textContent = message || ''; error.hidden = !message;
  };
  OneACartDrawer.prototype.renderDiscount = function (cart) {
    if (!window.BundleStaffel) return;
    var code = window.BundleStaffel.activeCode(cart); var savings = Math.max(0, originalTotal(cart) - cart.total_price);
    var form = this.drawer.querySelector('[data-cd1a-discount-form]');
    var applied = this.drawer.querySelector('[data-cd1a-discount-applied]');
    var discount = this.drawer.querySelector('[data-cd1a-discount]');
    var suggestion = this.drawer.querySelector('[data-cd1a-discount-suggestion]');
    applied.hidden = !code; discount.hidden = !(code && savings > 0); suggestion.hidden = true;
    if (code) {
      applied.querySelector('[data-cd1a-discount-name]').textContent = code;
      applied.querySelector('[data-cd1a-discount-amount]').textContent = '−' + money(savings);
      discount.querySelector('[data-cd1a-code]').textContent = code;
    } else if (cart.item_count >= 2) {
      var result = window.BundleStaffel.calculate(cart.item_count, originalTotal(cart));
      var suggestedCode = window.BundleStaffel.codeForTier(result.current);
      suggestion.querySelector('[data-cd1a-discount-suggestion-text]').textContent = 'Du hast ' + cart.item_count + ' Produkte im Warenkorb. Mit dem Code ' + suggestedCode + ' sparst du ' + result.currentPercent + ' %.';
      suggestion.querySelector('[data-cd1a-discount-suggestion-button]').dataset.code = suggestedCode;
      suggestion.hidden = false;
    }
  };
  OneACartDrawer.prototype.applyDiscount = function (value) {
    var code = String(value || '').trim().toUpperCase();
    if (!code || !window.BundleStaffel) return;
    var self = this; var form = this.drawer.querySelector('[data-cd1a-discount-form]'); var button = form.querySelector('button[type="submit"]');
    this.showDiscountError('');
    var active = window.BundleStaffel.activeCode(this.cart);
    if (active && active.toUpperCase() !== code) { this.showDiscountError('Es kann immer nur ein Code gelten. Entferne den aktiven Code, um diesen zu nutzen.'); return; }
    button.disabled = true; button.setAttribute('aria-busy', 'true');
    window.BundleStaffel.setDiscounts([code]).then(function (cart) {
      var applicable = Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (entry) { return entry && typeof entry.code === 'string' && entry.code.toUpperCase() === code && entry.applicable === true; });
      if (applicable) { form.elements.discount.value = ''; self.render(cart); return; }
      return window.BundleStaffel.setDiscounts([]).then(function (cleanCart) { self.render(cleanCart); self.showDiscountError('Der Code konnte nicht eingelöst werden.'); });
    }).catch(function () { self.showDiscountError('Der Code konnte nicht eingelöst werden.'); }).then(function () { button.disabled = false; button.removeAttribute('aria-busy'); });
  };
  OneACartDrawer.prototype.removeDiscount = function () {
    if (!window.BundleStaffel) return;
    var self = this; this.showDiscountError('');
    window.BundleStaffel.setDiscounts([]).then(function (cart) { self.render(cart); }).catch(function () {});
  };
  OneACartDrawer.prototype.renderRecommendations = function (cart) {
    var ids = cart.items.map(function (item) { return String(item.product_id); }); var shown = 0;
    this.drawer.querySelector('[data-cd1a-recommendation-title]').textContent = cart.item_count ? 'Passt dazu' : 'Beliebt gerade';
    this.drawer.querySelectorAll('.cd1a-rec').forEach(function (card) {
      var visible = shown < 2 && ids.indexOf(card.dataset.productId) === -1;
      card.classList.toggle('is-visible', visible); if (visible) shown += 1;
    });
    this.drawer.querySelector('[data-cd1a-recommendations]').hidden = shown === 0;
  };
  OneACartDrawer.prototype.handleClick = function (event) {
    if (event.target.closest('[data-cd1a-discount-remove]')) { this.removeDiscount(); return; }
    var suggestion = event.target.closest('[data-cd1a-discount-suggestion-button]');
    if (suggestion) { this.applyDiscount(suggestion.dataset.code); return; }
    var itemButton = event.target.closest('[data-key] [data-quantity]');
    if (itemButton) { this.change(itemButton.closest('[data-key]').dataset.key, Number(itemButton.dataset.quantity)); return; }
    var addButton = event.target.closest('[data-cd1a-add]');
    if (addButton) this.add(Number(addButton.dataset.cd1aAdd));
  };
  OneACartDrawer.prototype.change = function (key, quantity) {
    if (this.busy) return; this.busy = true; var self = this;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) })
      .then(function (response) { if (!response.ok) throw new Error('Cart change failed'); return response.json(); })
      .then(function (cart) { self.busy = false; self.render(cart); document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true })); })
      .catch(function () { self.busy = false; });
  };
  OneACartDrawer.prototype.add = function (variantId) {
    if (this.busy) return; this.busy = true; var self = this;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function (response) { if (!response.ok) throw new Error('Cart add failed'); return fetch('/cart.js'); })
      .then(function (response) { return response.json(); }).then(function (cart) { self.busy = false; self.render(cart); }).catch(function () { self.busy = false; });
  };
  OneACartDrawer.prototype.updateBadge = function (itemCount) {
    try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(itemCount), timestamp: Date.now() })); } catch (error) {}
    document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (element) { element.textContent = itemCount > 0 ? String(itemCount) : ''; });
    ['cart:update', 'cart-update', 'theme:cart-update'].forEach(function (name) { document.dispatchEvent(new CustomEvent(name, { detail: { data: { itemCount: itemCount } }, bubbles: true })); });
  };
  function init() {
    try { window.oneACartDrawer = new OneACartDrawer(); } catch (error) { window.oneACartDrawer = { open: function () {}, close: function () {}, drawer: null }; }
    if (window._cd1aPending) { delete window._cd1aPending; window.oneACartDrawer.open(); }
    document.dispatchEvent(new CustomEvent('cart-drawer:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
